<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp w-100"
  >
    <template>
      <v-card
        v-if="qrland"
        class="rounded-lg w-100 d-flex align-center fill-height"
        elevation="0"
      >
        <custom-tabs
          :tabsItemsAttrs="{}"
          style="width: 100%"
          class="pa-2"
          :tab-items="tabis"
          v-model="tabs"
          grow
          show-arrows
        >
          <template v-slot:staticItems>
            <v-tabs-items v-model="tabs" class="mb-3 pa-2" touchless>
              <v-tab-item>
                <commercialListItemOne
                  :info="info"
                  :admin="admin"
                  :loadingPage="loading"
                />
              </v-tab-item>
              <v-tab-item>
                <!-- <commercialListItemTwo
                  :info="info"
                  :loadingPage="loading"
                  :admin="admin"
                /> -->
                <commercial-list-item-two-pay />
              </v-tab-item>
              <!-- <v-tab-item>
                <commercialListItemTree
                  :info="info"
                  :loadingPage="loading"
                  :admin="admin"
                />
              </v-tab-item> -->
              <v-tab-item>
                <commercialListItemFour
                  :info="infos"
                  :loadingPage="loading"
                  :qrland="qrland"
                  :admin="admin"
                  :update="update"
                />
              </v-tab-item>
              <v-tab-item v-if="!admin">
                <commercial-list-item-six-user
                  :info="infos"
                  :loadingPage="loading"
                  :qrland="qrland"
                  :admin="admin"
                  :update="update"
                />
              </v-tab-item>
            </v-tabs-items>
          </template>
        </custom-tabs>
      </v-card>
      <v-progress-linear
        class="w-100"
        v-else
        indeterminate
        color="primary"
      ></v-progress-linear>
    </template>
  </help-info-wrapper>
</template>

<script>
import commercialListItemOne from "./commercialListCo/commercialListItemOne.vue";
import commercialListItemTwo from "./commercialListCo/commercialListItemTwo.vue";
import commercialListItemTree from "./commercialListCo/commercialListItemTree.vue";
import commercialListItemFour from "./commercialListCo/commercialListItemFour.vue";
import commercialListItemFive from "./commercialListCo/commercialListItemFive.vue";
import commercialListItemSixUser from "./commercialListCo/commercialListItemSix/commercialListItemSixUser.vue";
import CommercialListItemSixAdmin from "./commercialListCo/commercialListItemSix/commercialListItemSixAdmin.vue";
import commercialListItemSevenUser from "./commercialListCo/commercialListItemSeven/commercialListItemSevenUser.vue";
import commercialListItemSevenAdmin from "./commercialListCo/commercialListItemSeven/commercialListItemSevenAdmin.vue";
import CommercialListItemTwoPay from "./commercialListCo/commercialListItemTwoPay/commercialListItemTwoPay.vue";
export default {
  components: {
    commercialListItemOne,
    commercialListItemTwo,
    commercialListItemTree,
    commercialListItemFour,
    commercialListItemFive,
    CommercialListItemSixAdmin,
    commercialListItemSixUser,
    commercialListItemSevenUser,
    commercialListItemSevenAdmin,
    CommercialListItemTwoPay,
  },
  name: "commercialList",
  props: {
    selectShop: [Object],
    qrland: [String, Number],
    admin: Boolean,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "commercialList",
      loading: false,
      tabs: 0,
      info: {},
      infoRent: [],
      infoCharge: [],
      infoPay: [],
      infos: {},
      selectTabs: "paid",
      tabis: [
        {
          text: "مدیریت لیست پرداختی",
          value: "pay",
          icon: "cash-sync",
        },
        {
          text: "مدیریت  لیست پرداخت نشده ها",
          value: "rent",
          icon: "cash-clock",
        },
        // {
        //   text: "مدیریت شارژ ماهانه",
        //   value: "charge",
        //   icon: "cash-clock",
        // },
        {
          text: "مدیریت  نمایش",
          value: "charge",
          icon: "view-grid-plus-outline",
        },
        {
          text: "درخواست تبلیغات",
          value: "advertising",
          icon: "credit-card-settings-outline",
        },
      ],
    };
  },

  methods: {
    async fetch() {
      this.loading = true;
      await this.$api
        .get(
          this.admin
            ? `/v1/commercial/orders/${this.qrland}?qr=${this.selectShop.qr_id}&type=${this.selectTabs}`
            : `/v1/commercial/user/${this.selectShop.id}?qr_id=${this.qrland}'`,
        )
        .then((data) => {
          this.info = this.admin ? data.data.info : data.data.info.data;
        })
        .finally(() => (this.loading = false));
    },

    async update() {
      this.loading = true;

      await this.$api
        .get(
          this.admin
            ? `${this.$appUrl}/v1/commercial/${this.qrland}`
            : `/v1/commercial/user?qr=${this.qrland}`,
        )
        .then((data) => {
          this.infos = data.data.info?.find(
            (item) => item.qr_id == this.selectShop.qr_id,
          );
        })
        .finally(() => (this.loading = false));
    },
  },

  watch: {
    selectShop: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.info = {};

          this.fetch();
          this.update();
        }
      },
    },
    // info: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     if (val) {
    //       this.infoRent = val.orders.filter((item) => item.type === "rent");
    //       this.infoCharge = val.orders.filter((item) => item.type === "charge");
    //       this.infoPay = val.orders.filter((item) => item.is_paid);
    //     }
    //   },
    // },
    selectTabs() {
      this.info = {};
      this.fetch();
    },
    tabs() {
      this.selectTabs();
    },
  },
};
</script>

<style></style>
